import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import DashboardTraining from './features/dashboard/DashboardTraining';
import DashboardSelfStudyAdmin from './features/dashboard/DashboardSelfStudyAdmin';
import DashboardSelfStudyDetail from './features/dashboard/DashboardSelfStudyDetail';
// import SummaryRuleSettings from './features/summaryrule/SummaryRuleSettings';
import NotFoundPage from './components/ui/notFound';
import './App.css';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { Auth, Hub } from 'aws-amplify';
import CustomAuthenticator from './features/login/CustomAuthenticator';
import DatadownloadContainer from './features/datadownload/DatadownloadContainer';

Amplify.configure({
  aws_user_pools_id: import.meta.env.VITE_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: import.meta.env.VITE_AWS_USER_POOLS_CLIENT_ID,
});

function App() {
  const [isSignedIn, setIsSignedIn] = useState(false);

  const headerStyle = import.meta.env.VITE_ENV_VERSION !== 'prod' ? '#111827' : '#00B0B9';
  //    process.env.VITE_ENV_VERSION !== "prod" ? "#00B0B9" : "#111827";

  const appName =
    import.meta.env.VITE_ENV_VERSION !== 'prod'
      ? `VRL Dashboard - ${import.meta.env.VITE_ENV_VERSION}`
      : 'VRL Dashboard';

  useEffect(() => {
    // Check the current user when the component mounts
    Auth.currentAuthenticatedUser()
      .then(() => {
        setIsSignedIn(true);
      })
      .catch(() => {
        setIsSignedIn(false);
      });

    // Set up Hub listener
    const listener = Hub.listen('auth', (data) => {
      switch (data.payload.event) {
        case 'signIn':
          setIsSignedIn(true);
          break;
        case 'signOut':
          setIsSignedIn(false);
          break;
        default:
          break;
      }
    });

    // Clean up Hub listener on component unmount
    return () => {
      Hub.remove('auth', listener);
    };
  }, []);

  return (
    <Authenticator.Provider>
      <div className="overflow-y-hidden">
        {!isSignedIn && (
          <header
            className="p-4 mb-10 text-white flex justify-between items-center w-full"
            style={{ backgroundColor: headerStyle }}
          >
            <h1 className="text-2xl font-bold">{appName}</h1>
          </header>
        )}
        <CustomAuthenticator hideSignUp={true}>
          <div translate="no">
            <div>
              {/* Header */}
              <HelmetProvider>
                <Helmet>
                  <title>vrl-dashboard</title>
                  <meta name="description" content="Generated by create next app" />
                  <link rel="icon" href="src/assets/favicon.ico" />
                </Helmet>
              </HelmetProvider>

              <main className="flex">
                <Routes>
                  <Route path={`/`} element={<Navigate to="/dashboard" />} />
                  <Route path={`/dashboard`} element={<DashboardTraining />} />
                  {/* <Route path={`/setting`} element={<SummaryRuleSettings />} /> */}
                  <Route
                    path={`/dashboard_selfstudy_admin`}
                    element={<DashboardSelfStudyAdmin />}
                  />
                  <Route
                    path={`/dashboard_selfstudy_admin_detail`}
                    element={<DashboardSelfStudyDetail />}
                  />
                  <Route path={`/downloadcsv`} element={<DatadownloadContainer />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
            </div>
          </div>
        </CustomAuthenticator>
      </div>
    </Authenticator.Provider>
  );
}

export default App;
